import domain from './domain';

// Reset task client feedback
export const resetTaskClientFeedback = domain.createEvent('resetTaskClientFeedback');

// Reset task client feedback summary
export const resetTaskClientFeedbackSummary = domain.createEvent('resetTaskClientFeedbackSummary');
